<div *ngIf="pageNumber>1" class="paginator-container">
  <button class="hidden" [disabled]="currentPage === 1" (click)="firstPage()" mat-button>اولین</button>
  <button [disabled]="currentPage === 1" (click)="perviosPage()" mat-icon-button>
    <mat-icon>navigate_next</mat-icon>
  </button>
  <div *ngIf="pageNumber>1" (click)="firstPage()" class="number" [ngClass]="{'active': currentPage === 1}">1</div>
  <div *ngIf="pageNumber>5 && currentPage>2">...</div>
  <ng-container *ngFor="let page of arrayPageNumber;index as i">
    <ng-container *ngIf="pageNumber >5; else elseTemplate">
      <div
        *ngIf="(i+1 !==1 && i+1 !==pageNumber) && (i+1 ===currentPage || i+1 ===currentPage+1|| i+1 ===currentPage-1)"
        (click)="changeCurrentPage(i+1)" class="number" [ngClass]="{'active': currentPage === i+1}">{{i+1}}</div>
    </ng-container>
    <ng-template #elseTemplate>
      <div *ngIf="(i+1 !==1 && i+1 !==pageNumber)" (click)=" changeCurrentPage(i+1)" class="number"
        [ngClass]="{'active': currentPage === i+1}">{{i+1}}</div>
    </ng-template>
  </ng-container>
  <div *ngIf="pageNumber>5 && currentPage < pageNumber && currentPage !== pageNumber-1">...</div>
  <div (click)="lastPage()" class="number" [ngClass]="{'active': currentPage === pageNumber}">{{pageNumber}}</div>
  <button [disabled]="currentPage === pageNumber" (click)="nextPage()" mat-icon-button>
    <mat-icon>navigate_before</mat-icon>
  </button>
  <button class="hidden" [disabled]="currentPage === pageNumber" (click)="lastPage()" mat-button>اخرین</button>
</div>
